import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLink,
  moreLabel = "查看全部",
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b border-background-200 pb-3">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-primary-500" />
        <div>
          <h2 className="flex items-center gap-2 font-serif-cn text-xl font-bold text-foreground-950 md:text-2xl">
            {icon && <i className={`${icon} text-primary-500`} />}
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}